/**
 * 到店提醒
 */
import { VEHICLEENTRY } from '../types';

export default {
    name: `${VEHICLEENTRY}`,
    path: '/vehicleEntry',
    component: () => import(/* webpackChunkName: 'arriveRemind' */ '@/views/arriveRemindGroup/'),
    redirect: { name: `${VEHICLEENTRY}Index` },
    meta: {
        title: '到店提醒',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VEHICLEENTRY}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'arriveRemind' */ '@/views/arriveRemindGroup/home/Home.vue'),
        },
    ],
};
